<template>
  <div>
    <form>
      <div class="containerDiv">
        <span class="ContentSection">Basic Information</span>
        <table class="userContent">
          <tr>
            <td :class="{ 'hasError': $v.form.firstName.$error }">
              <label>
                First Name
                <span class="requiredinput">*</span>
              </label>
              <br />
              <input v-bind:disabled="!this.userDetails.enabled && isOpenInEditFlow" type="text" class="pl-2 pr-2"
                v-model.trim="form.firstName" @change="onInputChange" :tabindex="tabindex + 1" v-sanitize-html="form.firstName" />
            </td>
            <td>
              <label>Middle Initial</label>
              <br />
              <input v-bind:disabled="!this.userDetails.enabled && isOpenInEditFlow" maxlength="1"
                :tabindex="tabindex + 2" class="pl-2 pr-2" style="width:100px !important;"
                v-model.trim="form.middleInitial" @change="onInputChange" v-sanitize-html="form.middleInitial" />
            </td>
            <td :class="{ 'hasError': $v.form.lastName.$error }">
              <label>
                Last Name
                <span class="requiredinput">*</span>
              </label>
              <br />
              <input v-bind:disabled="!this.userDetails.enabled && isOpenInEditFlow" class="pl-2 pr-2"
                :tabindex="tabindex + 3" v-model.trim="form.lastName" @change="onInputChange" v-sanitize-html="form.lastName" />
            </td>
            <td :class="{ 'hasError': $v.form.userName.$error }">
              <label>
                Username
                <span class="requiredinput">*</span>
              </label>
              <br />
              <input class="pl-2 pr-2 user-name" :tabindex="tabindex + 4" v-model.trim="form.userName"
                @change="onInputChange" v-bind:disabled="isConfirmUser == true && isOpenInEditFlow" v-sanitize-html="form.userName" />
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <label>Title</label>
              <br />
              <input v-bind:disabled="!this.userDetails.enabled && isOpenInEditFlow" class="pl-2 pr-2"
                :tabindex="tabindex + 5" style="width:412px !important;" v-model.trim="form.title" @change="onInputChange"
                v-sanitize-html="form.title" />
            </td>
            <td :class="{ 'hasError': $v.form.phone.$error }">
              <label>
                Phone
                <span class="requiredinput">*</span>
              </label>
              <br />
              <input v-bind:disabled="!this.userDetails.enabled && isOpenInEditFlow" class="pl-2 pr-2"
                :tabindex="tabindex + 6" v-model.trim="form.phone" @change="onInputChange" v-sanitize-html="form.phone" />
            </td>
            <td :class="{ 'hasError': $v.form.email.$error }">
              <label>
                Email
                <span class="requiredinput">*</span>
              </label>
              <br />
              <input class="pl-2 pr-2" :tabindex="tabindex + 7" v-model.trim="form.email" disabled="disabled" 
                     v-sanitize-html="form.email" />
            </td>
          </tr>
        </table>
      </div>
    </form>
    <div class="containerDiv">
      <span class="ContentSection">Address</span>
      <table class="userContent">
        <tr>
          <td>
            <label>Street</label>
            <br />
            <textarea v-bind:disabled="!this.userDetails.enabled && isOpenInEditFlow" class="pl-2 pr-2"
              :tabindex="tabindex + 8" style="width:412px !important; resize:none;" v-model.trim="form.streetAddress"
              v-sanitize-html="form.streetAddress" />
          </td>
          <td colspan="2" style="vertical-align:baseline;">
            <label>City</label>
            <br />
            <input class="pl-2 pr-2" :tabindex="tabindex + 9"
              v-bind:disabled="!this.userDetails.enabled && isOpenInEditFlow" v-model.trim="form.city" v-sanitize-html="form.city" />
          </td>
          <td style="vertical-align:baseline;">
            <label>State/Province</label>
            <br />
            <input class="pl-2 pr-2" :tabindex="tabindex + 10"
              v-bind:disabled="!this.userDetails.enabled && isOpenInEditFlow" v-model.trim="form.state" v-sanitize-html="form.state" />
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <label>Zip/Postal Code</label>
            <br />
            <input v-bind:disabled="!this.userDetails.enabled && isOpenInEditFlow" class="pl-2 pr-2"
              :tabindex="tabindex + 11" style="width:412px !important;" v-model.trim="form.postalCode" v-sanitize-html="form.postalCode" />
          </td>
          <td>
            <label>Country</label>
            <br />
            <input class="pl-2 pr-2" :tabindex="tabindex + 12"
              v-bind:disabled="!this.userDetails.enabled && isOpenInEditFlow" v-model.trim="form.country"
              v-sanitize-html="form.country" />
          </td>
          <td>
            <label>
              Preferred Language
              <span class="requiredinput">*</span>
            </label>
            <br />
            <select v-model="form.languagePreference" v-bind:disabled="!this.userDetails.enabled && isOpenInEditFlow"
              class="pl-2 pr-2" :tabindex="tabindex + 12">
              <option v-for="languageOption in languageOptions" v-bind:value="languageOption.value"
                v-bind:key="languageOption.value">
                {{ languageOption.text }}
              </option>
            </select>

          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { eventbus } from "../../main";
import {
  required,
  minLength,
  email,
  helpers
} from "vuelidate/lib/validators";
const unvalidatior = helpers.regex(
  "userName",
  /^[^|#,$%^&:;?<>*{}~[\]()"'/+@=\s]*$/i
);
//const usernameRegex = helpers.regex('alpha', /^[^|#,$%^&:;?<>*{}~[\]()"'\/\+@=\s]*[^|#,$%^&:;?<>*{}~[\]()"'\/\+@=\s]+[^|#,$%^&:;?<>*{}~[\]()"'\/\+@=\s]*$/);
export default {
  name: "UserForm",
  components: {},
  props: {
    startTabIndex: Number,
    isConfirmUser: Boolean,
    userDetails: {
      firstName: String,
      middleInitial: String,
      lastName: String,
      userName: String,
      title: String,
      phone: String,
      email: String,
      streetAddress: String,
      city: String,
      state: String,
      postalCode: String,
      country: String,
      enabled: Boolean,
      languagePreference: String
    },
    isOpenInEditFlow: Boolean
  },
  data() {
    return {
      tabindex: this.startTabIndex,
      form: {
        firstName: this.userDetails.firstName,
        middleInitial: this.userDetails.middleInitial,
        lastName: this.userDetails.lastName,
        userName: this.userDetails.userName,
        title: this.userDetails.title,
        phone: this.userDetails.phone,
        email: this.userDetails.email,
        streetAddress: this.userDetails.streetAddress,
        city: this.userDetails.city,
        state: this.userDetails.state,
        postalCode: this.userDetails.postalCode,
        country: this.userDetails.country,
        enabled: this.userDetails.enabled,
        languagePreference: this.userDetails.languagePreference
      },
      languageOptions: this.$store.getters.languagePreference,

    };
  },
  validations: {
    form: {
      firstName: { required, minLength: minLength(1) },
      lastName: { required, minLength: minLength(1) },
      userName: { unvalidatior, required, minLength: minLength(1) },
      phone: { required },
      email: { required, email, minLength: minLength(1) },
      languagePreference: { required }
    }
  },
  methods: {
    getvalue() {
      this.$v.form.$touch();
      eventbus.$emit("setUserDetails", this.form);
    },
    getConfirmvalue() {
      this.$v.form.$touch();
      eventbus.$emit("setConfirmUserDetails", this.form);
    },
    onInputChange: function () {
      this.$emit("onFormDirty", true);
    }
  }
};
</script>

<style scoped>
.containerDiv {
  margin-bottom: 5px;
}

.ContentSection {
  font-weight: 600;
  font-size: 0.9rem;
}

.userContent td {
  padding-right: 30px;
}

.userContent td label {
  font-size: 0.9rem;
  margin-bottom: 0;
}

.hasError label {
  color: red !important;
}

.hasError input {
  border-color: red !important;
}

.userContent td input {
  width: 280px;
  border: 1px solid #8e8eca;
  border-radius: 0.2em;
  height: 1.7em;
  font-size: 0.9rem;
}

.userContent td select {
  width: 280px;
  border: 1px solid #8e8eca;
  border-radius: 0.2em;
  height: 1.7em;
  font-size: 0.9rem;
}

.userContent td textarea {
  width: 280px;
  border: 1px solid #8e8eca;
  border-radius: 0.2em;
  font-size: 0.9rem;
}

.applicationSection table {

  margin-top: 0.8em;
  width: 60%;
}

.applicationSection thead {
  border-bottom: 1.5px solid #8e8eca;
  border-top: 1.5px solid #8e8eca;
}

.userContent td select:disabled {
  color: black;
  background: rgba(239, 239, 239, 0.3);
}

.applicationSection thead th {
  background-color: white;
  cursor: pointer;
  font-weight: normal;
  font-size: 0.9rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border-collapse: collapse;
  padding: 3px 20px;
}

.applicationSection td {
  border-bottom: 1px solid #e0dddd;
  background-color: white;
  font-weight: normal;
  font-size: 0.9rem;
  padding: 4px 20px;
}

.adduserbtn {
  margin-left: 0.8em;
  background-color: #2c87f0;
  border: 1px solid #2c87f0;
  height: 2.6em;
  border-radius: 5px;
  font-size: 0.9rem;
  color: white;
  width: 5.2em;
}

.requiredinput {
  color: red;
}

.slider.round {
  border-radius: 34px;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #a1a6ab;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.switch {
  position: relative;
  display: inline-block;
  width: 45px;
  height: 20px;
  vertical-align: middle;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: bold;
}

.svg-green {
  color: green !important;
  margin-right: 5px;
}

.svg-gray {
  color: gray !important;
  margin-right: 5px;
  cursor: pointer;
}

.errorMessage {
  color: red;
  font-size: 0.9rem;
  font-weight: 500;
}

.PointerCursor {
  cursor: pointer;
}
</style>